const dummy = require('./dummy');
const myGov = require('./mygov');
const wep = require('./wep');
const idfcfa = require('./idfcfa');
const prestige = require('./prestige');
const bajaj = require('./bajaj');
const cub = require('./cub');
const canara = require('./canara');

module.exports = [dummy, myGov, wep, idfcfa, prestige, bajaj, cub, canara];
